const panama = [
  { "code": "Bocas del Toro Province", "name": "Bocas del Toro" },
  { "code": "Chiriquí Province", "name": "Chiriquí" },
  { "code": "Coclé Province", "name": "Coclé" },
  { "code": "Colón Province", "name": "Colón" },
  { "code": "Darién Province", "name": "Darién" },
  { "code": "Herrera Province", "name": "Herrera" },
  { "code": "Los Santos Province", "name": "Los Santos" },
  { "code": "Panamá Province", "name": "Panamá" },
  { "code": "Panamá Oeste Province", "name": "Panamá Oeste" },
  { "code": "Veraguas Province", "name": "Veraguas" },
  { "code": "Emberá-Wounaan Comarca", "name": "Emberá-Wounaan" },
  { "code": "Guna Yala Comarca", "name": "Guna Yala" },
  { "code": "Ngäbe-Buglé Comarca", "name": "Ngäbe-Buglé" },
  { "code": "Madugandí Comarca", "name": "Madugandí" },
  { "code": "Wargandí Comarca", "name": "Wargandí" }
]
export default panama;